import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M9 6a.75.75 0 01.75-.75h9.75A3.75 3.75 0 0123.25 9v1.875a.75.75 0 01-1.5 0V9a2.25 2.25 0 00-2.25-2.25h-9v7.5a.75.75 0 01-1.5 0V6zM1.5 2.25a.75.75 0 01.75.75v15a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M.75 14.25a.75.75 0 01.75-.75h9.75a.75.75 0 010 1.5H1.5a.75.75 0 01-.75-.75zM.75 6a.75.75 0 01.75-.75h8.25a.75.75 0 010 1.5H1.5A.75.75 0 01.75 6zM15 12.75v7.5h6v-5.314l-2.186-2.186H15zm-1.17-1.17c.21-.212.497-.33.795-.33h4.5a.75.75 0 01.53.22l2.625 2.625c.141.14.22.331.22.53v6a1.125 1.125 0 01-1.125 1.125h-6.75a1.125 1.125 0 01-1.125-1.125v-8.25c0-.298.118-.585.33-.796z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M19.125 11.25a.75.75 0 01.75.75v1.875h1.875a.75.75 0 010 1.5h-2.625a.75.75 0 01-.75-.75V12a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
